<!-- Dev Tools Modal -->
@if (isOpen() && !isMinimized()) {
  <div class="dev-tools-overlay">
    <div
      #devToolsModal
      class="dev-tools-modal"
      [style.left.px]="position().x"
      [style.top.px]="position().y"
      [style.width.px]="size().width"
      [style.height.px]="size().height"
    >
      <!-- Header with Tabs -->
      <div class="modal-header">
        <!-- Draggable overlay - transparent layer for dragging -->
        <div class="header-drag-area" (mousedown)="startDrag($event)"></div>

        <div class="header-left">
          <div class="drag-handle" (mousedown)="startDrag($event)">
            <span class="fa fa-grip-vertical"></span>
          </div>
          <app-dev-tools-panel [availableHeight]="contentHeight()"/>
        </div>
        <div class="header-actions">
          <button
            class="header-btn minimize"
            (click)="minimizeModal()"
            title="Minimize"
          >
            <span class="fa fa-window-minimize"></span>
          </button>
          <button
            class="header-btn maximize"
            (click)="maximizeModal()"
            title="Toggle fullscreen"
          >
            <span class="fa" [class.fa-window-restore]="isMaximized()" [class.fa-window-maximize]="!isMaximized()"></span>
          </button>
          <button
            class="header-btn close"
            (click)="closeDevTools()"
            title="Close"
          >
            ×
          </button>
        </div>
      </div>

      <!-- Resize Handles -->
      <div class="resize-handle resize-n" (mousedown)="startResize($event, 'n')"></div>
      <div class="resize-handle resize-s" (mousedown)="startResize($event, 's')"></div>
      <div class="resize-handle resize-e" (mousedown)="startResize($event, 'e')"></div>
      <div class="resize-handle resize-w" (mousedown)="startResize($event, 'w')"></div>
      <div class="resize-handle resize-ne" (mousedown)="startResize($event, 'ne')"></div>
      <div class="resize-handle resize-nw" (mousedown)="startResize($event, 'nw')"></div>
      <div class="resize-handle resize-se" (mousedown)="startResize($event, 'se')"></div>
      <div class="resize-handle resize-sw" (mousedown)="startResize($event, 'sw')"></div>
    </div>
  </div>
}

<!-- Minimized Bar -->
@if (isMinimized()) {
  <div class="minimized-bar">
    <button class="minimized-content" (click)="restoreModal()">
      <span class="fa fa-bug"></span>
      <span>Debug</span>
    </button>
    <button class="minimized-close" (click)="closeDevTools()">×</button>
  </div>
}